import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  updateAccountNameDone,
  updateAccountNameError,
  updateAccountNameLoading,
  updateAccountNameSuccess
} from '../actions/accountAdmins';
import { adminApi } from '../api/AdminApi';
import { UPDATE_ACCOUNT_NAME } from '../actions/actionTypes';

export function* watchUpdateAccountNameSaga () {
  yield takeLatest(UPDATE_ACCOUNT_NAME, updateAccountNameSaga);
}

export function* updateAccountNameSaga ({ tenantId, name }) {
  try {
    yield put(updateAccountNameLoading());
    const tenant = yield call(adminApi.updateTenantName, tenantId, name);
    yield put(updateAccountNameSuccess(tenant));
  } catch (error) {
    yield put(updateAccountNameError(error));
  } finally {
    yield put(updateAccountNameDone());
  }
}

export default [
  fork(watchUpdateAccountNameSaga)
];
